import {IEmpresa, ITipoCuestionario} from './index';

export interface INotification {
  Type: TypeNotification;
  Message: string;
  Data: any;
  DataList: any[];
}

export enum TypeNotification {
  success = 0,
  error = 1,
  info = 2,
  warning = 3,
}
